import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmacionModalComponent } from '../confirmationModal/confirmationModal.component';
import { SubscriptionsService } from '../../../infrastructure/services/subscriptions.service';
import { ChannelsService } from '../../../infrastructure/services/channels.service';
import { ProductsService } from '../../../infrastructure/services/products.service';
import { setTimeout } from 'timers';
import { Observable } from 'rxjs/Observable';
import { OutputService } from 'app/infrastructure/services/output.service';
import { ProductReportService } from 'app/infrastructure/services/productreport.service';
import { OrganizationService } from 'app/infrastructure/services/organization.service';
import { Translator } from 'angular-translator';
import { PaymentGatewayService } from 'app/infrastructure/services/payment.gateways.service';

@Component({
  templateUrl: './deleteEntity.component.html',
  selector: 'sx-eliminar-entidad',
})
export class EliminarEntidadComponent implements OnInit {
  // sistema | negocio | producto | output | productreport
  @Input() tipoEntidad: string;
  @Input() codSubscription: string;
  @Input() codOrganization: string;
  @Input() codChannel: string;
  @Input() codProduct: string;
  @Input() codProductReport: string;
  @Input() codOutput: string;

  @Output() eliminado: EventEmitter<any> = new EventEmitter();

  constructor(private modalService: NgbModal,
    private translator: Translator,
    private subscriptionsService: SubscriptionsService,
    private organizationService: OrganizationService,
    private channelsService: ChannelsService,
    private productService: ProductsService,
    private outputService: OutputService,
    private productReportService: ProductReportService) { }

  ngOnInit() {
  }

  pedirConfirmacion() {
    const modalRef = this.modalService.open(ConfirmacionModalComponent);

    const modalInstance = <ConfirmacionModalComponent>modalRef.componentInstance;
    const text = <string>this.translator.instant('DISABLE_TEXT');
    modalInstance.titulo = `${text} ${this.codProduct || this.codChannel || this.codProductReport || this.codOutput || this.codSubscription || this.codOrganization}?`;

    modalRef.result
      .then(confirmacion => {
        this.eliminarEntidad().subscribe(ok => this.eliminado.emit('ok'));
      },
        reason => { /* Do nothing */ }
      );
  }

  private eliminarEntidad(): Observable<any> {
    if (this.tipoEntidad === 'organizacion') {
      return this.organizationService.eliminarSistema(this.codOrganization);
    }
    if (this.tipoEntidad === 'subscription') {
      return this.subscriptionsService.deleteSubscription(this.codOrganization, this.codSubscription);
    }

    if (this.tipoEntidad === 'channel') {
      return this.channelsService.deleteChannel(this.codOrganization, this.codSubscription, this.codChannel);
    }

    if (this.tipoEntidad === 'product') {
      return this.productService.deleteProduct(this.codOrganization, this.codSubscription, this.codChannel, this.codProduct);
    }
    
    if (this.tipoEntidad === 'output') {
      return this.outputService.delete(this.codOutput, this.codSubscription);
    }

  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/helpers/components/deleteEntity/deleteEntity.component.ts